import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';

const COOKIE_CONSENT_KEY = 'ucan_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);

    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acknowledge = () => {
    localStorage.setItem(
      COOKIE_CONSENT_KEY,
      'essential_acknowledged'
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto bg-gray-900 text-white rounded-2xl shadow-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-8 h-8 text-yellow-400 flex-shrink-0 hidden sm:block" />

        <div className="flex-1 min-w-0">
          <p className="text-sm leading-relaxed">
            U-CAN utiliza cookies y almacenamiento local esenciales
            para mantener tu sesión, recordar tus preferencias y
            permitir el funcionamiento seguro del servicio. No
            utilizamos estas tecnologías para publicidad ni
            seguimiento entre apps o sitios web.{' '}
            <Link
              to="/privacy"
              className="text-[#E6202E] hover:underline font-medium"
            >
              Política de Privacidad
            </Link>
          </p>
        </div>

        <Button
          size="sm"
          onClick={acknowledge}
          className="bg-[#E6202E] hover:bg-[#D31522] text-white text-xs flex-shrink-0"
          data-testid="cookie-acknowledge-btn"
        >
          Entendido
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
